import { render, staticRenderFns } from "./ServiceCoverage.vue?vue&type=template&id=19d54af6&"
import script from "./ServiceCoverage.vue?vue&type=script&lang=js&"
export * from "./ServiceCoverage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCoverage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports